import { useMemo } from "react";

import { FormInstance } from "antd/es/form/hooks/useForm";
import { IntlShape } from "react-intl";

import validatePasswords from "@app/util/validatePasswords";

export const useCurrentPasswordValidationRules = (intl: IntlShape) =>
  useMemo(
    () => [
      {
        message: intl.formatMessage({
          id: "navbar.userMenu.changePassword.modal.currentPassword.validation.required",
          defaultMessage: "Please input your current password",
          description:
            "Validation message for the Current Password field in the Change Password modal",
        }),
        required: true,
      },
    ],
    [intl]
  );

export const useNewPasswordFieldValidationRules = (intl: IntlShape) =>
  useMemo(
    () => [
      {
        message: intl.formatMessage({
          id: "navbar.userMenu.changePassword.modal.newPassword.validation.required",
          defaultMessage: "Please input your new password",
          description: "Validation message for the New Password field in the Change Password modal",
        }),
        required: true,
      },
      {
        validator: (rule: {}, value: string) => {
          const isValid = validatePasswords(value, value);
          if (isValid) {
            return Promise.resolve();
          }
          return Promise.reject();
        },
      },
    ],
    [intl]
  );

export const useConfirmPasswordFieldValidationRules = (intl: IntlShape, form: FormInstance) =>
  useMemo(
    () => [
      {
        message: intl.formatMessage({
          id: "navbar.userMenu.changePassword.modal.confirmPassword.validation.required",
          defaultMessage: "Please confirm your password",
          description:
            "Validation message for the Confirm Password field in the Change Password modal",
        }),
        required: true,
      },
      {
        validator: (rule: {}, value: string) => {
          if (!value || form.getFieldValue("password") === value) {
            return Promise.resolve();
          }
          return Promise.reject();
        },
      },
    ],
    [intl, form]
  );
